export default "__VITE_ASSET__DvYhmQY1__"